<template>
  <DealsModal
    v-if="productResponse?.hasDeals"
    :product-id="productResponse.productId"
    :product-name="productResponse.titles.raw"
  />
</template>

<script setup lang="ts">
import DealsModal from '@backmarket/nuxt-layer-recommendation/DealsModal.vue'

import { useFetchProduct } from '~/scopes/product-core/composables/useFetch/useFetchProduct/useFetchProduct'

const { data: productResponse } = useFetchProduct()
</script>
